var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.209 11.3965L17.3496 20.2559C16.5586 21.0469 15.1875 20.4932 15.1875 19.3594V14.2969H8.01562C7.31426 14.2969 6.75 13.7326 6.75 13.0312V7.96874C6.75 7.26738 7.31426 6.70312 8.01562 6.70312H15.1875V1.64062C15.1875 0.512102 16.5533 -0.0468826 17.3496 0.744133L26.209 9.60351C26.6994 10.0992 26.6994 10.9008 26.209 11.3965ZM10.125 19.9922V17.8828C10.125 17.5348 9.84023 17.25 9.49219 17.25H5.0625C4.1291 17.25 3.375 16.4959 3.375 15.5625V5.43749C3.375 4.50409 4.1291 3.74999 5.0625 3.74999H9.49219C9.84023 3.74999 10.125 3.46523 10.125 3.11718V1.00781C10.125 0.659758 9.84023 0.374992 9.49219 0.374992H5.0625C2.26758 0.374992 0 2.64257 0 5.43749V15.5625C0 18.3574 2.26758 20.625 5.0625 20.625H9.49219C9.84023 20.625 10.125 20.3402 10.125 19.9922Z",
    fill: "#CBCBCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.dfdbc66ff16583603dfc642219ac3833.svg";
export { ForwardRef as ReactComponent };